module.exports = __webpack_public_path__ + "img/pk_lausanne.9393e0aa.png";